export default "__VITE_ASSET__CbClkUlZ__"